import { Modal, ModalProps } from './Modal'
import { combineClasses } from '~/util'

import styles from './IFrameModal.module.scss'

interface IFrameModalProps extends Omit<ModalProps, 'children'> {
  /**
   * The URL of the HTML page to display in the iframe.
   */
  url: string
  /**
   * additional props for modal.
   */
  modalProps?: object
  /**
   * additional props for iframe.
   */
  iframeProps?: object
}

/**
 * `IFrameModal` displays an iframe inside of a modal. The iframe content is
 * given an outer margin so the user can see the modal overlay. You can force
 * the iframe to take the full modal area using `layout: fullscreen`. Note that
 * you will need to make sure the close button is easy to see and interact with
 * because it will be absolutely positioned in the top right corner above the
 * iframe.
 */
export function IFrameModal({
  isOpen,
  setIsOpen,
  url,
  label,
  iframeProps,
  className,
  ...rest
}: IFrameModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      label={`${label} Window`}
      {...rest}
    >
      <iframe
        data-testid="iframe"
        title={label}
        src={url}
        className={combineClasses(styles.iframe, className)}
        {...iframeProps}
      />
    </Modal>
  )
}
